import {
  initialChannelMessages,
  initialChannels,
  initialRoutingRules
} from '../../mocks/channels.js';

let nextRuleId = 100;
let nextMessageId = 100;

/**
 * Channels slice (cutover §3): `channelsMode` flips to 'live' only when
 * GET /api/channels succeeds (ChannelsPage fetch-first); the mock seeds stay
 * as the labeled sample fallback. Namespaced `channelsMode` — a bare `mode`
 * would collide with approvalsSlice/agentsSlice keys in the merged store.
 */
export const createChannelsSlice = (set) => ({
  channels: initialChannels,
  routingRules: initialRoutingRules,
  channelMessages: initialChannelMessages,
  channelsMode: 'sample',

  setChannelsData: ({ channels, routingRules }, mode) => set({
    ...(Array.isArray(channels) ? { channels } : {}),
    ...(Array.isArray(routingRules) ? { routingRules } : {}),
    channelsMode: mode === 'live' ? 'live' : 'sample'
  }),

  setChannelsMode: (mode) => set({ channelsMode: mode === 'live' ? 'live' : 'sample' }),

  setChannels: (channels) => set({ channels }),

  toggleChannel: (channelId) => set((state) => ({
    channels: state.channels.map((channel) => (
      channel.id === channelId
        ? { ...channel, enabled: !(channel.enabled ?? true) }
        : channel
    ))
  })),

  toggleAgentOnChannel: (channelId, agentId) => set((state) => ({
    channels: state.channels.map((channel) => {
      if (channel.id !== channelId) return channel;
      const enabled = channel.enabledAgentIds ?? [];
      const next = enabled.includes(agentId)
        ? enabled.filter((id) => id !== agentId)
        : [...enabled, agentId];
      return { ...channel, enabledAgentIds: next };
    })
  })),

  addRoutingRule: (rule) => set((state) => ({
    routingRules: [...state.routingRules, { ...rule, id: `rule-${nextRuleId++}` }]
  })),

  updateRoutingRule: (ruleId, changes) => set((state) => ({
    routingRules: state.routingRules.map((rule) => (
      rule.id === ruleId ? { ...rule, ...changes } : rule
    ))
  })),

  removeRoutingRule: (ruleId) => set((state) => ({
    routingRules: state.routingRules.filter((rule) => rule.id !== ruleId)
  })),

  addChannelMessage: (message) => set((state) => ({
    channelMessages: [
      { ...message, id: `msg-${nextMessageId++}` },
      ...state.channelMessages
    ].slice(0, 100)
  })),

  markChannelMessage: (messageId, status) => set((state) => ({
    channelMessages: state.channelMessages.map((message) => (
      message.id === messageId ? { ...message, status } : message
    ))
  }))
});
